import React, { useState, useMemo } from 'react';
import styled from 'styled-components';
import PopUp from '../../Common/PopUp/PopUp';
import TitleWithInfo from '../../Common/TitleWithInfo/TitleWithInfo';
import GraphHOC from '../../Common/GraphHOC/GraphHOC';
import BarGraph from '../../Common/BarGraph/BarGraph';
import { setPopUpActive } from '../../store/redux/slices/topicSlice';
import { useDispatch, useSelector } from 'react-redux';

const Wrapper = styled.div`
  display: flex;
  height: 85%;
  position: relative;
`;
// const Wrapper = styled.div`
//   display: flex;
//   align-items: end;
//   justify-content: space-between;
//   gap: 50px;
//   height: 85%;
//   user-select: none;
//   position: relative;
// `;


const GraphLabelWrapper = styled.div`
  font-family: inherit;
  
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: end;
`;
const GraphWrapper = styled.div`
  flex: 1;
  padding: 20px;
`;

const GraphAxis = styled.div`
  height: 100%;
  width: 90%;
  position: relative;

  /* AXIS */
  &::before {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 2px;
    height: 100%;
    background: rgba(0,0,0,0.4);
  }

  &::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 2px;
    background: rgba(0,0,0,0.4);
  }

  /* POINTS */
  .clusterPoints {
    position: absolute;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    cursor: pointer;
    z-index: 5;
    border: 1px solid #222;
  }

  /* 🔥 CLUSTER STYLE (LIKE IMAGE) */
  .clusterCircles {
    position: absolute;
    border-radius: 50%;
    cursor: pointer;

    backdrop-filter: blur(2px);

    transition: all 0.3s ease;
  }

`;

const ReviewWrapper = styled.div`
  position: relative;
  // padding: 20px;
  z-index: 400;
`;

const Review = styled.div`
  box-sizing: border-box;
  max-width: 280px;
  min-width:195px;
  // height: 50px;
  position: absolute;
  bottom: 20px;
  left: 25px;
  border-radius: 8px;
  // background: #e2e2fe;
  background: ${(props) =>
    props?.isReview ? 'rgb(0 213 208 / 52%)' : '#e2e2fe'};
  z-index: 400;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);

  padding: 10px;

  color: #2a2929;
  font-size: 12px;
  font-weight: 400;
  font-family: inherit;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const Pointer2 = styled.div`
  width: 0px;
  height: 0px;
  position: absolute;
  bottom: 5px;
  left: 170px;
  // z-index: 5;
  z-index: 400;
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  // border-top: 18px solid #e2e2fe;
  // border-top:  white;
  border-top: 18px solid rgb(226, 226, 254);
`;


const GraphLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  color: #2a2929;
  font-size: 16px;
  font-weight: 400;
  font-family: inherit;

  &:before {
    content: '';
    display: inline-block;
    width: 16px;
    height: 16px;
    border-radius: 2px;
    // background: red;
    background: ${(props) => props.backgroundColor};
  }
`;

const TextWrapper = styled.div`
  text-align: left;
  overflow: scroll !important;
  font-family: inherit;
  & > * {
    float: left;
    clear: both;
    margin-bottom: 10px;
    padding: 5px 10px;
  }

  span {
    font: Open Sans;
    font-weight: 600;
    font-size: 20px;
    margin-bottom: 25px;
    font-family: inherit;
  }
`;

const Message = styled.div`
  color: #2a2929;
  text-align: left;
  // font-family: inherit;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  font-family: inherit;
`;

const Name = styled.div`
  color: #2a2929;

  // font-family: inherit;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  font-family: inherit;
`;


const CancelButton = styled.span`
  cursor: pointer;
  float: right;
  margin: 20px 20px 0px 0px;
  color: #2a2929;
  text-align: center;
  // font-family:inherit;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  font-family: inherit;
`;
/* ✅ AXIS CALCULATION (SAFE) */
const findAxisPoints = (values, maxRadius = 0) => {
  if (!values || values.length === 0) {
    return { minValue: 0, axisRange: 100 };
  }

  let min = Math.min(...values);
  let max = Math.max(...values);

  if (min === max) {
    min -= 10;
    max += 10;
  }

  const padding = Math.max(20, maxRadius);

  const adjustedMin = min - padding;
  const adjustedMax = max + padding;

  return {
    minValue: adjustedMin,
    axisRange: (adjustedMax - adjustedMin) || 1
  };
};

const ClusterAnalysisGraph = ({
  channel = '',
  xAxisValues = [],
  yAxisValues = [],
  sentiment = [],
  sentimentColor = {},
  reviews = [],
  circle = [],
  sentimentLabel,
  ids = [],

  title = 'Sentiments',
  job_id,
  type = '',
  name = [],
  date = [],
  likes = [],
  helpful = [],
  moduleType,
  dislikesCount,
  likesCount,
}) => {

  const [selectedCluster, setSelectedCluster] = useState(null);
  const handleOpen =(val)=> {
    console.log("insijnjfndjnvjfn");
    
    setSelectedCluster(val)
  }
  const dispatch = useDispatch();

  const [summary, setSummary] = useState('');
  const [reviewMessage, setReviewMessage] = useState(-1);
  const [userName, setUserName] = useState(-1);
  const [postDate, setPostDate] = useState(-1);
  const [tweetLikes, setTweetLikes] = useState(-1);
  const [helpfulCount, setHelpfulCount] = useState(-1);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [likesCnt, setLikesCnt] = useState(-1);
  const [dislikes, setDislikes] = useState(-1);
  const [showGraphData, setShowGraphData] = useState(true);

  const handleReset = () => setSelectedCluster(null);

  /* ✅ FILTER DATA (RADIUS BASED) */
  // const filtered = useMemo(() => {
  //   if (!selectedCluster) {
  //     return {
  //       xVals: xAxisValues,
  //       yVals: yAxisValues,
  //       sentiments: sentiment,
  //       reviewsList: reviews,
  //     };
  //   }

  //   const { x, y, radius } = selectedCluster;

  //   const newX = [];
  //   const newY = [];
  //   const newS = [];
  //   const newR = [];

  //   xAxisValues.forEach((val, i) => {
  //     const dx = val - x;
  //     const dy = yAxisValues[i] - y;
  //     const dist = Math.sqrt(dx * dx + dy * dy);

  //     if (dist <= radius * 2.5) { // 🔥 tweak if needed
  //       newX.push(val);
  //       newY.push(yAxisValues[i]);
  //       newS.push(sentiment[i]);
  //       newR.push(reviews[i]);
  //     }
  //   });

  //   if (newX.length === 0) {
  //     return {
  //       xVals: xAxisValues,
  //       yVals: yAxisValues,
  //       sentiments: sentiment,
  //       reviewsList: reviews,
  //     };
  //   }

  //   return {
  //     xVals: newX,
  //     yVals: newY,
  //     sentiments: newS,
  //     reviewsList: newR,
  //   };
  // }, [selectedCluster, xAxisValues, yAxisValues, sentiment, reviews]);

  const filtered = useMemo(() => {
  if (!selectedCluster) {
    return {
      xVals: xAxisValues,
      yVals: yAxisValues,
      sentiments: sentiment,
      reviewsList: reviews,
      idsList: ids,
      namesList: name,
      dateList: date,
      likesList: likes,
      helpfulList: helpful,
      likesCountList: likesCount,
      dislikesCountList: dislikesCount,
    };
  }

  const { x, y, radius } = selectedCluster;

  const newData = {
    xVals: [],
    yVals: [],
    sentiments: [],
    reviewsList: [],
    idsList: [],
    namesList: [],
    dateList: [],
    likesList: [],
    helpfulList: [],
    likesCountList: [],
    dislikesCountList: [],
  };

  xAxisValues.forEach((val, i) => {
    const dx = val - x;
    const dy = yAxisValues[i] - y;
    const dist = Math.sqrt(dx * dx + dy * dy);

    if (dist <= radius * 2.5) {
      newData.xVals.push(val);
      newData.yVals.push(yAxisValues[i]);
      newData.sentiments.push(sentiment[i]);
      newData.reviewsList.push(reviews[i]);

      newData.idsList.push(ids?.[i]);
      newData.namesList.push(name?.[i]);
      newData.dateList.push(date?.[i]);
      newData.likesList.push(likes?.[i]);
      newData.helpfulList.push(helpful?.[i]);
      newData.likesCountList.push(likesCount?.[i]);
      newData.dislikesCountList.push(dislikesCount?.[i]);
    }
  });

  // fallback if empty
  if (newData.xVals.length === 0) {
    return {
      xVals: xAxisValues,
      yVals: yAxisValues,
      sentiments: sentiment,
      reviewsList: reviews,
      idsList: ids,
      namesList: name,
      dateList: date,
      likesList: likes,
      helpfulList: helpful,
      likesCountList: likesCount,
      dislikesCountList: dislikesCount,
    };
  }

  return newData;
}, [
  selectedCluster,
  xAxisValues,
  yAxisValues,
  sentiment,
  reviews,
  ids,
  name,
  date,
  likes,
  helpful,
  likesCount,
  dislikesCount
]);
  /* ✅ AXIS */
  const { minValue: xMin, axisRange: xRange } = findAxisPoints(filtered.xVals);
  const { minValue: yMin, axisRange: yRange } = findAxisPoints(filtered.yVals);

  const xPercent = (v) =>
    xRange ? ((v - xMin) / xRange) * 100 : 50;

  const yPercent = (v) =>
    yRange ? ((v - yMin) / yRange) * 100 : 50;

  /* 🎨 CLUSTER COLORS */
  const clusterColors = [
    'rgba(120,140,255,0.18)',
    'rgba(120,255,180,0.18)',
    'rgba(255,140,140,0.18)',
    'rgba(255,220,120,0.18)',
  ];

  const label = Object.entries(sentimentLabel)?.map(([key, value]) => (
    <GraphLabel key={key} backgroundColor={sentimentColor[key]}>
      {value}
    </GraphLabel>
  ));


  const sentimentsData = [
    {
      name: 'Positive',
      value: parseFloat(summary?.positive_sentiment || 0),
      // fill: 'rgba(3, 198, 82, 0.8)',
      fill: '#36D174',
    },
    {
      name: 'Negative',
      value: parseFloat(summary?.negative_sentiment || 0),
      // fill: 'rgba(238, 19, 7,  0.8)',
      fill: '#F14239',
    },
    {
      name: 'Neutral',
      value: parseFloat(summary?.neutral_sentiment || 0),
      // fill: 'rgba(255, 225, 69, 0.8)',
      fill: '#FCDE94',
    },
  ];

  const emotionsData = [
    {
      name: 'Neutral',
      value: summary?.neutral || 0,
      fill: 'rgba(251, 214, 121,  0.8)',
    },
    {
      name: 'Surprise',
      value: summary?.surprise || 0,
      fill: 'rgba(3, 198, 82,  0.8)',
    },
    {
      name: 'Joy',
      value: summary?.joy || 0,
      fill: 'rgba(218, 6, 184,  0.8)',
    },
    {
      name: 'Fear',
      value: summary?.fear || 0,
      fill: 'rgba(255, 153, 0,  0.8)',
    },
    {
      name: 'Sadness',
      value: summary?.sadness || 0,
      fill: 'rgba(21, 112, 203,  0.8)',
    },
    {
      name: 'Anger',
      value: summary?.anger || 0,
      fill: 'rgba(238, 19, 7,  0.8)',
    },
    {
      name: 'Disgust',
      value: summary?.disgust || 0,
      fill: 'rgba(84, 30, 192,  0.8)',
    },
  ];

  const options = ['Bar Graph', 'Pie Chart', 'Donut Chart', 'Funnel Chart'];
  const renderScreen = {
    'Bar Graph': (
      <BarGraph
        clusterShow={true}
        data={title == 'Emotions' ? emotionsData : sentimentsData}
        type={'%'}
        showDrillThrough={false}
        /*  borderRadius={'0px 12px 12px 0px'} */
        barHeight={'32px'}
      />
    ),
  };
  const handleRedirect = (val) => {
    let tenant = JSON.parse(sessionStorage.getItem('brandUser'));
    let tenant_id = tenant?.tenant_id
    let tenant_name = tenant?.tenant_name
    let new_url = ''
    if(channel == 'instagram'){
      new_url = `https://qa.brandastra.ai/${tenant_name}/post?channel=${channel}&uuid=${tenant_id}&job=${job_id}&id=${val}&is_comment=${1}`
    
    }else{
      new_url = `https://qa.brandastra.ai/${tenant_name}/post?channel=${channel}&uuid=${tenant_id}&job=${job_id}&id=${val}`
    }
    window.open(new_url, '_blank')
  }
  const handleCopy = (text) => {
    navigator.clipboard.writeText(text).then(
      () => {
        // alert('Text copied to clipboard!');
      },
      (err) => {
        alert('Failed to copy text: ', err);
      }
    );
  };

  const handleShowSummary = (data) => {
    console.log("====================dddddddddd==================");
    dispatch(setPopUpActive(true))
    // console.log(data, "daaa");
    setShowGraphData(true);
    setIsPopupOpen(true);
    setSummary(data);
    setReviewMessage(-1);
    setHelpfulCount(-1);
    setUserName(-1);
    setPostDate(-1);
    setTweetLikes(-1);
    setLikesCnt(-1);
    setDislikes(-1);
  };


  const handleClick = (index,x) => {
    

    dispatch(setPopUpActive(true))
    if (selectedCluster) {
      setShowGraphData(false);
      if (
        index === reviewMessage ||
        index === userName ||
        index === postDate ||
        index === tweetLikes ||
        index === helpfulCount ||
        index === likesCnt ||
        index === dislikes
      ) {
        setReviewMessage(-1);
        setHelpfulCount(-1);
        setUserName(-1);
        setPostDate(-1);
        setTweetLikes(-1);
        setIsPopupOpen(false);
        setLikesCnt(-1);
        setDislikes(-1);
      } else {
        setReviewMessage(index);
        setUserName(index);
        setHelpfulCount(index);
        setPostDate(index);
        setTweetLikes(index);
        setIsPopupOpen(true);
        setLikesCnt(index);
        setDislikes(index);
      }
      setSummary('');

    }
  };

  return (
    <Wrapper>

      {/* BACK BUTTON */}
      {selectedCluster && (
        <button
          onClick={handleReset}
          style={{ position: 'absolute', top: -20, left: -20, zIndex: 10 }}
        >
          ← Back
        </button>
      )}
      {
        xAxisValues?.length > 0 ?

          <GraphWrapper>
            <GraphAxis>

              {/* POINTS */}
              {filtered.xVals.map((x, i) => (
                <div
                  key={i}
                  className="clusterPoints"
                  style={{
                    left: `${xPercent(x)}%`,
                    bottom: `${yPercent(filtered.yVals[i])}%`,
                    background: sentimentColor[filtered.sentiments[i]],
                  }}
                  title={filtered.reviewsList[i]}

                  onClick={() => handleClick(i,x)}
                >
                </div>
              ))}

              {/* ALL CLUSTERS */}
              {!selectedCluster &&
                circle.map((c, i) => (
                  <div
                    key={i}
                    className="clusterCircles"
                    style={{
                      left: `${xPercent(c.x)}%`,
                      bottom: `${yPercent(c.y)}%`,
                      width: `${(c.radius / xRange) * 500}%`,
                      height: `${(c.radius / yRange) * 500}%`,
                      transform: 'translate(-50%, 50%)',

                      // background: clusterColors[i % clusterColors.length],
                      background: 'rgb(242 244 255)',

                      // boxShadow: `
                      //   inset 0 0 40px ${clusterColors[i % clusterColors.length]},
                      //   0 0 80px ${clusterColors[i % clusterColors.length]}
                      // `
                    }}
                    onClick={() => handleOpen(c)}
                  />
                ))}

              {/* SELECTED CLUSTER */}
              {selectedCluster && (
                <div
                  className="clusterCircles"
                  style={{
                    left: `${xPercent(selectedCluster.x)}%`,
                    bottom: `${yPercent(selectedCluster.y)}%`,
                    width: `${(selectedCluster.radius / xRange) * 500}%`,
                    height: `${(selectedCluster.radius / yRange) * 500}%`,
                    transform: 'translate(-50%, 50%)',
                    background: 'rgb(242 244 255)',

                    // background: 'rgba(120,140,255,0.2)',

                    // boxShadow: `
                    //   inset 0 0 40px rgba(120,140,255,0.3),
                    //   0 0 100px rgba(120,140,255,0.25)
                    // `
                  }}

                  onClick={() => handleShowSummary(selectedCluster)}
                >


                  <ReviewWrapper>
                    <Review>
                      Summary - {selectedCluster.summary}
                      <br />
                      {/* {type} - {sentimentLabel[sentiment[index]]} */}
                    </Review>
                    <Pointer2></Pointer2>
                  </ReviewWrapper>

                </div>
              )}

            </GraphAxis>
          </GraphWrapper>

          :
          <GraphWrapper
            style={{
              width: '100%',
              textAlign: 'center',
              justifyContent: 'center',
              alignItems: 'center',
              color: '#2a2929',
              display: 'flex'
            }}
          >
            {/* No Data Available */}Insufficient Data
          </GraphWrapper>
      }

      <GraphLabelWrapper>{label}</GraphLabelWrapper>
      {isPopupOpen && (
        <PopUp minWidth={'70%'} onClose={() => {setIsPopupOpen(false); dispatch(setPopUpActive(false))}}>
          {/* <span>cross</span>
          <div>{reviews[reviewMessage]}</div> */}
          <TextWrapper>
            {summary?.summary ? (
              <div>
                <TitleWithInfo
                  title={'Clustering Summary '}
                  infoText={`Clustering users based on their discussions on similar topics.`}
                />
              </div>
            ) : (
              <span
                style={{
                  color: '#2a2929',
                }}
              >
                Review
              </span>
            )}

            {/* <Name>{name[userName]}</Name> */}
            <Name>{filtered?.namesList[userName]}</Name>
            {/* {summary?.summary ? (
              <></>
            ) : moduleType === 'Twitter' ? (
              <Message>Post on {dateList[postDate]}</Message>
            ) : (
              <Message>Reviewed on {date[postDate]}</Message>
            )} */}
            {summary?.summary ? (
              <></>
            ) : <Message>
                {moduleType === 'Twitter'
                  ? `Post on ${filtered.dateList[postDate]}`
                  : `Reviewed on ${filtered.dateList[postDate]}`
                }
              </Message>}
            

            {showGraphData && (
              <div style={{ width: '90%' }}>
                <GraphHOC
                  // title={'Gender Demographics'}
                  options={options}
                  renderScreen={renderScreen}
                  // startDate={startDateParsed}
                  // endDate={endDateParsed}
                  option={'Bar Graph'}
                  hideDropdown={true}
                />
              </div>
            )}

            <br />
            <Message>{summary?.summary}</Message>
            <Message onClick={() => handleCopy(filtered?.reviewsList[reviewMessage])}>
              {filtered?.reviewsList[reviewMessage]}
            </Message>
            {/* <Message onClick={() => handleCopy(reviews[reviewMessage])}>
              {reviews[reviewMessage]}
              {filtered.reviewsList[reviewMessage]}
            </Message> */}

            {summary?.summary ? (
              <></>
            ) : moduleType === 'Twitter' ? (
              <div style={{ color: '#2a2929' }}>
                {/* {likes[tweetLikes] ? parseInt(likes[tweetLikes]) : 0} Likes */}
                {filtered?.likesList[tweetLikes] ? parseInt(filtered?.likesList[tweetLikes]) : 0} Likes
              </div>
            ) : (
              <>
                {moduleType === 'amazon' && filtered?.helpfulList[helpfulCount] ? (
                  <div
                    style={{
                      color: '#292A2A',
                    }}
                  >
                    {filtered?.helpfulList[helpfulCount]
                      ? parseInt(filtered?.helpfulList[helpfulCount])
                      : 0}{' '}
                    People found this helpful
                  </div>
                ) : moduleType === 'flipkart' ? (
                  <>
                    <div
                      style={{
                        color: '#292A2A',
                      }}
                    >
                      {likesCnt &&
                        filtered?.likesCountList?.length > 0 &&
                        filtered?.likesCountList[likesCnt] &&
                        parseInt(filtered?.likesCountList[likesCnt]) > 0
                        ? `${parseInt(filtered?.likesCountList[likesCnt])} Likes`
                        : '0 Likes'}{' '}
                    </div>
                    <div
                      style={{
                        color: '#292A2A',
                      }}
                    >
                      {dislikes &&
                        filtered?.dislikesCountList?.length > 0 &&
                        filtered?.dislikesCountList[dislikes]
                        ? `${parseInt(filtered?.dislikesCountList[dislikes])} Dislikes`
                        : `0 Dislikes`}{' '}
                    </div>
                  </>
                ) : (
                  <></>
                )}
              </>
            )}
            {
              summary?.ids ?
                <div
                  style={{
                    marginTop: '10px',
                    color: '#353cf7',
                    cursor: 'pointer',
                    fontWeight: 600,
                  }}
                  onClick={() => handleRedirect(summary?.ids)}
                >
                  
                  {
                    channel == 'instagram' ?  'View Related Comments →' : 'View Related Posts →'
                  }
                  
                </div>
                :
                filtered?.idsList?.length > 0 ?
                <div
                  style={{
                    marginTop: '10px',
                    color: '#353cf7',
                    cursor: 'pointer',
                    fontWeight: 600,
                  }}
                  // onClick={() => handleRedirect(ids[reviewMessage])}
                  onClick={() => handleRedirect(filtered?.idsList[reviewMessage])}
                >
                  {
                    channel == 'instagram' ?  'View Related Comment →' : ' View Related Post →'
                  }
                 
                </div>
                :
                <></>

            }

            <CancelButton onClick={() => {setIsPopupOpen(false); dispatch(setPopUpActive(false))}}>
              Close
            </CancelButton>
          </TextWrapper>
        </PopUp>
      )}
    </Wrapper>
  );
};

export default ClusterAnalysisGraph;